module.exports = __webpack_public_path__ + "img/swider.f2c72a7b.png";